import React from 'react';
import { Tooltip, Button } from 'antd';
// import { useCheckWarranty } from '../../../../api/queries/useCheckWarranty';
import IconComponent from '../IconComponent/IconComponent';
import { modes, tooltipTitles, warrantyIds } from '../../../../config';
import { useChangeWarrantyModalDispatch } from '../../../../model';
import styles from './NotWarranty.module.scss';

const Active = ({ request, actionProps = {} }) => {
  const { open } = useChangeWarrantyModalDispatch();

  return (
    <Tooltip title={tooltipTitles[warrantyIds.notWarranty].active}>
      <Button
        {...actionProps}
        ghost
        shape="circle"
        onClick={() => open({ request, mode: modes.regularToPossWarranty })}
      >
        <IconComponent
          warrantyId={request.garantyId}
          className={styles.icon}
        />
      </Button>
    </Tooltip>
  );
};

const NotWarrantyComponent = ({ request, actionProps }) => {
  // const { houseId, serviceId } = request;

  // const { data } = useCheckWarranty(
  //   { houseId, serviceId },
  //   { staleTime: Infinity, enabled: Boolean(houseId && serviceId) }
  // );

  // if (!data?.isWarranty || !houseId || !serviceId) return null;

  return (
    <Active
      request={request}
      actionProps={actionProps}
    />
  );
};

export default NotWarrantyComponent;
